export default __webpack_public_path__ + "static/media/ptichka2.b61cade9.jpg";